import { EmployeePreferences } from "@/interfaces/employee_type"
import { Switch } from "@/components/ui/switch"

export function DarkModeOption({ preferences, setPreference }: { 
    preferences: EmployeePreferences, 
    setPreference: (key: string, value: any) => void 
}) {
    return (
        <div className='flex flex-row gap-2 items-center'>
            <Switch 
                checked={preferences.darkMode as boolean}
                onCheckedChange={() => {
                    setPreference('darkMode', !preferences.darkMode)
                }}
            />
            <label className='text-lg'>Dark Mode</label>
        </div>
    )
}